import { action } from 'satcheljs/lib/legacy';
export default action('updateSubjectSelectionRange')(function updateSubjectSelectionRange(viewState, start, end) {
    viewState.subjectViewState.selectionStart = start;
    viewState.subjectViewState.selectionEnd = end;
});
//# sourceMappingURL=updateSubjectSelectionRange.js.map